module.exports = __webpack_public_path__ + "housingStatic/img/moudle_name_item3.de7b430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_center/moudle_name_item3.png
// module id = KqiD
// module chunks = 2